import { Link } from "react-router-dom";
import { Heart, MapPin, Radar } from "lucide-react";

export default function Landing() {
  return (
    <div className="min-h-screen sunny-bg relative overflow-hidden" data-testid="landing-page">
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-10 flex flex-col min-h-screen">
        <header className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Heart className="text-[#F43F5E] fill-[#F43F5E]" size={26} />
            <span className="font-display font-bold text-lg tracking-tight text-stone-900">Love at geo-point</span>
          </div>
          <Link to="/auth" data-testid="nav-login-btn" className="text-sm text-stone-500 hover:text-stone-900 transition-colors">Sign in</Link>
        </header>

        <div className="grid lg:grid-cols-2 gap-12 items-center flex-1 py-10">
          <div className="max-w-xl fade-up">
            <span className="inline-flex items-center gap-2 text-[#F43F5E] text-sm font-semibold tracking-widest uppercase mb-4">
              <MapPin size={15} /> New York City · Invite only
            </span>
            <h1 className="font-display font-extrabold text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-stone-900">
              You'll find love at <span className="text-[#F43F5E]">some point</span>.
            </h1>
            <p className="text-stone-600 text-lg mt-6 leading-relaxed">
              Do what you do, go where you go. Send us your coordinates and we'll find you love.
            </p>
            <div className="flex flex-wrap gap-4 mt-10">
              <Link to="/auth?mode=register" data-testid="get-started-btn"
                className="px-7 py-3.5 rounded-full bg-[#F43F5E] hover:bg-[#E11D48] text-white transition-colors font-semibold shadow-lg shadow-rose-500/25">
                Enter with invite
              </Link>
            </div>
          </div>

          <div className="relative fade-up">
            <div className="rounded-3xl overflow-hidden shadow-2xl shadow-amber-900/10 border-4 border-white rotate-1">
              <img src="https://customer-assets.emergentagent.com/job_radar-romance-1/artifacts/pqmjtz1q_Love%20coordinates.png" alt="Couple with geo coordinates" className="w-full h-[440px] object-cover" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pb-6">
          {[
            { icon: MapPin, t: "Drop your geo-point", d: "Pin your exact spot on the NYC map, and tell us what you're looking for." },
            { icon: Radar, t: "Romance radar", d: "Watch as we scan your neighborhood for matches." },
            { icon: Heart, t: "Find love under a tree", d: "No swiping, no browsing. Just show up at the geo-point we share." },
          ].map((f, i) => (
            <div key={i} className="bg-white/80 backdrop-blur border border-amber-100 rounded-2xl p-5 shadow-sm">
              <f.icon className="text-[#F43F5E] mb-3" size={22} />
              <div className="font-semibold text-stone-900">{f.t}</div>
              <div className="text-sm text-stone-500 mt-1">{f.d}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
